import { useEffect, useState } from "react";
import { api, API, fmtDDMMYYYY, DOC_TYPE_LABELS } from "../../api";
import { PageHeader, Panel, Pill, Empty } from "../../ui";

export default function DocumentsPage() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get(`${API}/doc-requests`).then(({ data }) => setList(data)); }, []);
  if (list === null) return <p className="text-sm text-slate-500">Loading…</p>;
  return (
    <div>
      <PageHeader title="Documents" subtitle="Every document request across every case. Agency review is separate from broker acceptance." />
      {list.length === 0 ? <Empty title="No requests yet" /> : (
        <Panel>
          <table className="w-full text-sm">
            <thead><tr className="border-b border-slate-200 text-[10.5px] tracking-[0.14em] uppercase text-slate-500 bg-slate-50"><th className="text-left px-5 py-3">Document</th><th className="text-left px-5 py-3">For</th><th className="text-left px-5 py-3">Period</th><th className="text-left px-5 py-3">Status</th><th className="text-left px-5 py-3">Broker</th><th className="text-left px-5 py-3">Updated</th></tr></thead>
            <tbody>
              {list.map((d) => (
                <tr key={d.id} className="border-b border-slate-100">
                  <td className="px-5 py-3 font-medium">{DOC_TYPE_LABELS[d.doc_type] || d.doc_type}</td>
                  <td className="px-5 py-3 text-slate-600">{d.related_ref?.label || "—"}</td>
                  <td className="px-5 py-3 text-slate-600">{d.period || "—"}</td>
                  <td className="px-5 py-3"><Pill tone={d.status === "agency_checked" ? "emerald" : d.status === "replacement_required" ? "rose" : d.status === "uploaded" ? "sky" : "amber"}>{d.status.replace(/_/g, " ")}</Pill></td>
                  <td className="px-5 py-3"><Pill tone={d.broker_status === "shared" ? "sky" : d.broker_status === "accepted" ? "emerald" : "slate"}>{d.broker_status.replace(/_/g, " ")}</Pill></td>
                  <td className="px-5 py-3 text-slate-600">{fmtDDMMYYYY(d.updated_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Panel>
      )}
    </div>
  );
}
